<template>
    <div>
    <div class="flex justify-center">
        <div class="w-4/5">
            <div class="flex items-center mt-10">
                <i class="el-icon-arrow-left font-bold text-xl cursor-pointer" @click="goBack" />
                <p class="text-xl ml-4 font-bold" style="color: #ff8e3b">Program Payment</p>
            </div>
            <!-- Institution payment: Order summary (5 rows) + method chips -->
            <div v-if="isInstitutionPayment" class="pay-info institution-order-card" style="width: 100%;padding: 15px 20px;box-sizing: border-box;margin-top: 25px;">
                <div class="flex justify-between items-center" style="flex-wrap: wrap; gap: 12px; margin-bottom: 8px;">
                    <p class="text-xl font-bold" style="margin: 0;">Order summary</p>
                    <div class="method-chips" v-if="!isPaymentCompleted">
                        <button type="button" class="method-chip" :class="{ active: paymentMethod === 'card' }" @click="paymentMethod = 'card'">Card (Stripe)</button>
                        <button type="button" class="method-chip" :class="{ active: paymentMethod === 'bank' }" @click="paymentMethod = 'bank'">Bank transfer</button>
                    </div>
                    <el-tag v-else type="success" size="medium">Paid</el-tag>
                </div>
                <p style="color:#6B6B64;font-size:13px;margin:0 0 14px;">
                    {{ applicationInfo.project_info.project_ename || applicationInfo.project_info.project_name }}
                    <span v-if="applicationInfo.account_name"> ｜ Institution: {{ applicationInfo.account_name }}</span>
                </p>
                <div class="flex justify-between text-lg my-3">
                    <p>Standard fee</p>
                    <p class="amt-orange">{{ currency }} {{ formatAmount(institutionAmounts.std) }}</p>
                </div>
                <div class="flex justify-between text-lg my-3">
                    <p>Applicable fee reduction</p>
                    <p class="amt-orange">&minus; {{ currency }} {{ formatAmount(institutionAmounts.red) }}</p>
                </div>
                <div class="flex justify-between text-lg my-3">
                    <p>Fee after reduction</p>
                    <p class="amt-orange">{{ currency }} {{ formatAmount(institutionAmounts.after) }}</p>
                </div>
                <div class="flex justify-between text-lg my-3">
                    <p>GST</p>
                    <p class="amt-orange">{{ currency }} 0.00</p>
                </div>
                <div class="flex justify-between text-lg my-3">
                    <p>Payment service fee <span class="svc-tag">{{ paymentMethod === 'card' ? 'card payment' : 'no card fee on bank transfer' }}</span></p>
                    <p class="amt-orange">{{ currency }} {{ formatAmount(institutionAmounts.svc) }}</p>
                </div>
                <div style="width: 100%;height: 1px;background-color: var(--c-primary);"></div>
                <div class="flex justify-between text-lg my-4 font-bold">
                    <p>Total order amount</p>
                    <p class="amt-orange">{{ currency }} {{ formatAmount(institutionAmounts.total) }}</p>
                </div>
            </div>

            <!-- Student payment: existing summary -->
            <div v-else class="pay-info" style="width: 100%;padding: 15px 20px;box-sizing: border-box;margin-top: 25px;">
                <div class="flex justify-between font-bold text-lg">
                    <p>Program</p>
                    <p style=" color: var(--c-primary);">{{ applicationInfo.project_info.project_ename ? applicationInfo.project_info.project_ename : applicationInfo.project_info.project_name }}</p>
                </div>
                <div class="flex justify-between text-lg my-4">
                    <p>Standard Fee</p>
                    <p style="font-weight: bold;color: #ff8e3b;">{{ currency }} {{ formatAmount(standard_fee)
                        }}</p>
                </div>
                <div v-if="applicationInfo.custom_price_status == 0">
                    <div class="flex justify-between text-lg my-4">
                        <p>Applicable Fee Reduction<span style="margin-left:5px;"><el-button type="text" @click="dialogVisible = true">
                            View Fee Reduction Details
                        </el-button></span></p>
                        <p style="font-weight: bold;color: #ff8e3b;">{{ currency }} {{ formatAmount(calcReductionFee()) }}</p>
                    </div>
                    <div class="flex justify-between text-lg my-4">
                        <p> Fee After Reduction</p>
                        <p style="font-weight: bold;color: #ff8e3b;">{{ currency }} {{ formatAmount(applicationInfo.total_price <=0 ? 0: applicationInfo.total_price)
                            }}</p>
                    </div>
                    <div class="flex justify-between text-lg my-4">
                        <p>Payment Service Fee</p>
                        <p style="font-weight: bold;color: #ff8e3b">{{ currency }} {{ formatAmount(serviceFee) }}</p>
                    </div>
                    <div class="flex justify-between text-lg my-4">
                        <p>GST</p>
                        <p style="font-weight: bold;color: #ff8e3b">{{ currency }} 0.00</p>
                    </div>

                </div>

                <div v-if="applicationInfo.custom_price_status == 1">
                    <div class="flex justify-between text-lg my-4">
                        <p>Custom Fee (after subsidy or discount)</p>
                        <p style="font-weight: bold;color: #ff8e3b">{{ currency }} {{ formatAmount(applicationInfo.total_price) }}</p>
                    </div>
                    <div class="flex justify-between text-lg my-4" v-if="applicationInfo.total_price > 0">
                        <p>Payment Service Fee</p>
                        <p style="font-weight: bold;color: #ff8e3b">{{ currency }} {{ formatAmount(serviceFee) }}</p>
                    </div>

                </div>


                <div style="width: 100%;height: 1px;background-color: var(--c-primary);"> </div>

                <div class="flex justify-between text-lg my-4 font-bold">
                    <p>Total Order Amount</p>
                    <p style="color: #ff8e3b">{{ currency }} {{ formatAmount(amount) }}</p>
                </div>
                <p style="font-style: italic;">*The service fee is charged by the payment platform. It is not
                    included in the registration fee.</p>
            </div>

            <!-- Already paid: confirmation panel -->
            <div v-if="isPaymentCompleted" class="pay-info" style="width: 100%;padding: 15px 20px;box-sizing: border-box;margin-top: 25px;">
                <p class="text-xl font-bold" style="color: #2E7D32;">Payment completed</p>
                <p style="margin-top:10px;line-height:24px;color:#6B6B64;">
                    This registration is marked <b>Paid</b>
                    <span v-if="applicationInfo.application_payment_channel"> via {{ applicationInfo.application_payment_channel }}</span>.
                    <span v-if="applicationInfo.application_payment_amount != null"> Amount recorded: {{ currency }} {{ formatAmount(applicationInfo.application_payment_amount) }}.</span>
                    <span v-if="applicationInfo.application_payment_date"> Payment date: {{ applicationInfo.application_payment_date }}.</span>
                </p>
                <div class="flex mt-4" style="gap: 12px; flex-wrap: wrap;">
                    <el-button class="btn institution-action-btn" @click="downloadInvoice">Download invoice / receipt</el-button>
                    <el-button class="btn" @click="goBack">Back</el-button>
                </div>
            </div>

            <!-- Institution: shared T&C (Card + Bank) — A-6.2 / C-6 -->
            <div v-if="!isPaymentCompleted && amount>0 && isInstitutionPayment" class="pay-info" style="width: 100%;padding: 15px 20px;box-sizing: border-box;margin-top: 25px;">
                <p class="text-xl font-bold">Terms and Conditions</p>
                <div class="institution-terms-box" v-html="project_refund_policy"></div>
                <div class="terms flex items-start" style="margin-top: 16px;">
                    <div @click="isAgree = !isAgree" style="display: flex; align-items: center; margin-top: 2px;">
                        <img style="width: 16px;height: 16px;cursor: pointer;margin-right: 16px;" v-if="!isAgree"
                            :src="require('../../assets/image/unchecked.png')" />
                        <img style="width: 16px;height: 16px;cursor: pointer;margin-right: 16px;" v-else
                            :src="require('../../assets/image/checked.png')" />
                    </div>
                    <p>I have read and accept the payment terms and conditions above.</p>
                </div>
                <p class="terms-note">{{ isAgree ? 'Terms accepted. You may continue with the selected payment method.' : 'Accept the terms and conditions to continue.' }}</p>
            </div>

            <!-- Institution: Card pay (after T&C) -->
            <div v-if="!isPaymentCompleted && amount>0 && isInstitutionPayment && paymentMethod === 'card'" class="pay-info" style="width: 100%;padding: 15px 20px;box-sizing: border-box;margin-top: 25px;">
                <p class="text-xl font-bold">Pay by card</p>
                <p style="margin-top:10px;line-height:24px;color:#6B6B64;">
                    Pay the license fee online by credit or debit card. The registration is confirmed as Paid as soon as Stripe settles the payment, and a receipt is issued immediately. A payment processing fee applies to card payments and is charged to the payer.
                </p>
            </div>

            <!-- Student T&C -->
            <div v-if="!isPaymentCompleted && amount>0 && !isInstitutionPayment" class="pay-info" style="width: 100%;padding: 15px 20px;box-sizing: border-box;margin-top: 25px;">
                <p class="text-xl font-bold">Terms and Conditions</p>
                <p class="ql-snow ql-editor" style="margin-top: 10px;line-height: 24px;font-size: 16px;"
                    v-html="project_refund_policy">
                </p>
                <div class="terms flex items-center justify-center" style="margin-top: 20px;">
                    <div @click="isAgree = !isAgree" style="display: flex; align-items: center">
                        <img style="width: 16px;height: 16px;cursor: pointer;margin-right: 16px;" v-if="!isAgree"
                            :src="require('../../assets/image/unchecked.png')" />
                        <img style="width: 16px;height: 16px;cursor: pointer;margin-right: 16px;" v-else
                            :src="require('../../assets/image/checked.png')" />
                    </div>
                    <p> I have read and agree on the terms and conditions.</p>
                </div>
            </div>

            <!-- Institution: Bank transfer (after T&C; proof gated on agree) -->
            <div v-if="!isPaymentCompleted && amount>0 && isInstitutionPayment && paymentMethod === 'bank'" class="pay-info" style="width: 100%;padding: 15px 20px;box-sizing: border-box;margin-top: 25px;">
                <p class="text-xl font-bold">Pay by bank transfer</p>
                <p style="margin-top:10px;line-height:24px;color:#6B6B64;">
                    Transfer the total order amount shown above, then upload your remittance advice or proof of payment. We verify the transfer manually; once verified, the registration status is updated to <b>Paid</b>.
                </p>
                <div class="bank-transfer-grid">
                    <div><span>Beneficiary name</span><strong>{{ bankInfo.beneficiary }}</strong></div>
                    <div><span>Account number</span><strong>{{ bankInfo.account }}</strong></div>
                    <div><span>Bank</span><strong>{{ bankInfo.bank }}</strong></div>
                    <div><span>SWIFT / BIC</span><strong>{{ bankInfo.swift }}</strong></div>
                </div>
                <div class="bank-policy">
                    <p>The program license fee is <b>{{ currency }} {{ formatAmount(institutionAmounts.after) }} net to beneficiary</b>. As this is a very small international payment amount, bank charges can materially reduce the amount received. If paying by international wire, please ensure that <b>all transfer charges are paid by the payer/remitter</b> and select <b>OUR / all charges paid by sender</b> where available.</p>
                    <p>If the transfer is sent with shared or beneficiary charges and we receive less than <b>{{ currency }} {{ formatAmount(institutionAmounts.after) }}</b> after bank deductions, the shortfall will remain payable before the license can be activated. To avoid delays and back-and-forth, please confirm the charge setting with your bank before submitting the wire.</p>
                    <p>To reduce transaction costs, the license fee may also be paid by credit card via Stripe. If international wire fees are high or difficult to allocate, an advisor may pay the <b>{{ currency }} {{ formatAmount(institutionAmounts.after) }}</b> license fee by card first and then request reimbursement from the school finance department. This often avoids disproportionate wire charges on a small payment amount and helps prevent delays caused by bank fee deductions.</p>
                </div>
                <div class="flex mt-4" style="gap: 12px; flex-wrap: wrap;">
                    <el-button class="btn institution-action-btn" @click="downloadInvoice">Download invoice</el-button>
                    <el-upload action="/" :show-file-list="false" :before-upload="beforeProofUpload" :disabled="!isAgree">
                        <el-button class="btn institution-action-btn" type="success" :loading="uploadingProof" :disabled="!isAgree">
                            {{ applicationInfo.institution_payment_proof_url ? 'Replace file' : 'Upload proof of payment' }}
                        </el-button>
                    </el-upload>
                </div>
                <div class="institution-proof-panel" v-if="applicationInfo.institution_payment_proof_url">
                    <div class="proof-name">{{ applicationInfo.institution_payment_proof_file_name || 'Uploaded proof' }}</div>
                    <div class="proof-meta">
                        <span v-if="applicationInfo.institution_payment_proof_uploaded_time">
                            Uploaded {{ formatProofUploadedTime(applicationInfo.institution_payment_proof_uploaded_time) }} · awaiting finance verification
                        </span>
                        <span v-else>{{ applicationInfo.institution_payment_proof_status || 'Awaiting finance verification' }}</span>
                    </div>
                    <div style="margin-top:7px;">
                        <a :href="applicationInfo.institution_payment_proof_url" target="_blank" rel="noopener noreferrer">View uploaded proof</a>
                        — Our finance team will verify the transfer. Once verified, the registration status is updated to <b>Paid</b> and a receipt is issued. You will be notified by email.
                    </div>
                </div>
            </div>
            <div v-if="!isPaymentCompleted && amount>0 && !isInstitutionPayment" class="pay-info" style="width: 100%;padding: 15px 20px;box-sizing: border-box;margin-top: 25px;">
                <p class="text-xl font-bold">NOTICE — Payment Using Another Person's Payment Method</p>
                <div style="margin-top: 10px;line-height: 24px;font-size: 16px;">
                    <p>
                        If you intend to pay for any program, service, or material using a credit card or other payment method issued to or held by another person — including, but not limited to, a parent's or guardian's card — you must inform the cardholder of this payment in full and obtain their consent before the transaction is completed.
                    </p>
                    <p style="margin-top: 12px;">
                        At the time of informing the cardholder, you must disclose, at minimum:
                    </p>
                    <ul style="margin: 8px 0 0 20px; padding: 0;">
                        <li>the purpose and nature of the payment, and the specific program, service, or material to which it relates;</li>
                        <li>the exact amount to be charged and the currency of the transaction;</li>
                        <li>the timing of the charge, including any recurring or future charges, if applicable; and</li>
                        <li>the terms and conditions and the refund policy that apply to the purchase.</li>
                    </ul>
                    <p style="margin-top: 12px;">
                        By completing the payment, you confirm and warrant that the cardholder has been fully informed of, and has authorized, the transaction. Using another person's payment method without their knowledge or consent is a misuse of the payment instrument and may constitute unauthorized use or fraud, which will be subject to the consequences set out in the Integrity Policy.
                    </p>
                </div>
                <div class="terms flex items-center justify-center" style="margin-top: 20px;">
                    <div @click="isCardholderAgree = !isCardholderAgree" style="display: flex; align-items: center">
                        <img style="width: 16px;height: 16px;cursor: pointer;margin-right: 16px;" v-if="!isCardholderAgree"
                            :src="require('../../assets/image/unchecked.png')" />
                        <img style="width: 16px;height: 16px;cursor: pointer;margin-right: 16px;" v-else
                            :src="require('../../assets/image/checked.png')" />
                    </div>
                    <p> I confirm and warrant that the cardholder has been fully informed of, and has authorized, the transaction.</p>
                </div>
            </div>
            <div v-if="!isPaymentCompleted && amount > 0 && (!isInstitutionPayment || paymentMethod === 'card')">
                <div v-if="applicationInfo?.project_info?.deadline_date" class="flex justify-center mb-4" style="color: #666; font-size: 14px;margin-top: 10px;">
                        <p>Payment Deadline: {{ new Date(applicationInfo.project_info.deadline_date).toLocaleDateString() + ' 23:59:59' }}  (Your Local Time)</p>
                    </div>
                    <div v-if="applicationInfo?.custom_deadline_date" class="flex justify-center mb-4" style="color: #666; font-size: 14px;margin-top: 10px;">
                        <p>Your Custom Payment Deadline: {{ new Date(applicationInfo.custom_deadline_date).toLocaleDateString() + ' 23:59:59' }}  (Your Local Time)</p>
                    </div>
                <div  class="w-full flex justify-center items-center" style="margin: 30px 0px; gap: 12px; flex-wrap: wrap;">
                    <el-button class="btn" @click="goBack">Cancel</el-button>
                    <el-button class="btn institution-action-btn" type="primary" :disabled="(isInstitutionPayment && !isAgree) || simulatingPay" :loading="simulatingPay" @click="goPay">
                        {{ isInstitutionPayment ? ('Confirm and pay ' + currency + ' ' + formatAmount(institutionAmounts.total)) : 'Pay by Card' }}
                    </el-button>
                </div>
            </div>
            <div v-if="!isPaymentCompleted && amount == 0" class="pay-info" style="width: 100%;padding: 15px 20px;box-sizing: border-box;margin-top: 25px;">
                <div class="text-center mb-6">
                    <p class="text-xl text-success font-bold mb-4" style="color: #67c23a">Registration Complete!</p>
                    <p class="text-base">Your registration has been successfully processed. Since there is no payment required, you are all set to proceed with the program.</p>
                </div>
            </div>
        </div>
              
        <el-dialog 
            class="fee-reduction-dialog" 
            title="Fee Reduction Policy" 
            :visible.sync="dialogVisible" 
            :close-on-click-modal="true" 
            width="80%">

            <el-row :gutter="24">
                <el-col :span="16">
                    <div>
                        <EAE_Fee_Reduction_Policy :price_reductions="applicationInfo.project_info.price_reductions"></EAE_Fee_Reduction_Policy>
            </div>
                </el-col>
                
                <el-col :span="8">
                    <div class="reduction-panel">
                        <h3 class="panel-title">Your Reduction Level</h3>
                        
                        <div class="reduction-info-card">
                            <div class="reduction-main-info">
                                <div class="reduction-level">
                                    <span class="level-label">Level</span>
                                    <span class="level-value">{{ applicationInfo.reduction_level_info.reduction_level }}</span>
                                </div>
                                <div class="level-formula">
                                    <span>MIN({{ applicationInfo.reduction_level_info.country_level }} + {{ applicationInfo.reduction_level_info.finish_level }} - {{applicationInfo.reduction_level_info.finish_level == 9? 4 : 1 }}, 8) {{ applicationInfo.reduction_level_info.target_offer > 0 ? '+ ' + applicationInfo.reduction_level_info.target_offer : '' }}</span>
                                </div>
                            </div>
                            
                            <div class="info-details">
                                <div class="info-item">
                                    <span class="info-label">Country/Region:</span>
                                    <span class="info-value">{{ applicationInfo.reduction_level_info.account_country }}</span>
                                </div>
                                <div class="info-item">
                                    <span class="info-label">Country Class:</span>
                                    <span class="info-value">{{ applicationInfo.reduction_level_info.country_level }}</span>
                                </div>
                                <div class="info-item">
                                    <span class="info-label">Tuition Tier:</span>
                                    <span class="info-value">{{ applicationInfo.reduction_level_info.finish_level }}</span>
                                </div>
                                <div class="info-item" v-if="applicationInfo.reduction_level_info.target_offer > 0">
                                    <span class="info-label">Target Offer:</span>
                                    <span class="info-value">{{ applicationInfo.reduction_level_info.target_offer }}</span>
                                </div>
                            </div>
                        </div>

                        <div class="info-box">
                            <p class="info-text">
                                If you've received financial aid, scholarships, or subsidies that have cut your tuition fees below the standard amount, you have the opportunity to apply for reclassification into a lower Tuition Tier for greater fee reduction.
                            </p>
                        </div>

                        <div class="upload-section">
                            <div class="upload-container">
                                <input 
                                    class="file-input" 
                                    name="file" 
                                    type="file" 
                                    accept=".pdf" 
                                    @change="getFile" 
                                />
                                <el-button 
                                    type="primary" 
                                    class="upload-button" 
                                    icon="el-icon-upload2">
                                    Apply for lower tier
                                </el-button>
                            </div>
                            
                            <div v-if="file" class="file-name">
                                <i class="el-icon-document"></i>
                                <span>{{ file.name }}</span>
                                <i class="el-icon-delete" @click="removeFile"></i>
                            </div>
                            
                            <div class="info-text instruction">
                                Compile documentation of your actual tuition fee payment into one PDF titled with your full name.
                            </div>
                        </div>

                        <div class="actions">
                            <el-button @click="dialogVisible=false">Cancel</el-button>
                            <el-button
                                type="primary"
                                :loading="loadDialog"
                                element-loading-spinner="el-icon-loading"
                                element-loading-background="rgba(255, 255, 255, 0.2)"
                                @click="submitTier()">
                                Submit
                            </el-button>
                        </div>
                    </div>
                </el-col>
            </el-row>
        </el-dialog>
    </div>
     <div class="empty-bottom"></div>
    </div>
</template>

<script>
import {
    checkApplication,uploadStudentTuitionTier,getQiniuToken,updateInstitutionPaymentProof,simulateProgramPayment
} from '../../api/eae'
import EAE_Fee_Reduction_Policy from '../../components/EAE_Fee_Reduction_Policy.vue';
import * as qiniu from 'qiniu-js'
import {
    getUserId,
    isTestUser,
    getTestPayAmountUsd
} from '../../utils/store'
import {
    calcInstitutionOrderAmounts,
    INSTITUTION_BANK,
    getInstitutionOrderTermsHtml
} from '../../utils/institutionPayment'
export default {
    name: "Payment",
    components: {
        EAE_Fee_Reduction_Policy
    },
    data() {
        return {
            application_id: this.$route.query.application_id,
            isAgree: false,
            isCardholderAgree: false,
            applicationInfo: {
                reduction_level_info: {
                    reduction_level: 2, 
                    target_offer: 0, 
                    country_level: 1, 
                    finish_level: "2", 
                    account_country: "China"
                }
            },
            project_refund_policy: '',
            isInstitutionPayment: false,
            paymentMethod: 'card',
            bankInfo: INSTITUTION_BANK,
            start_date: '',
            end_date: '',
            amount: 0,
            serviceFee: 0.00,
            standard_fee: 0,
            currency:'USD',
            dialogVisible: false,
            tierData1: [],
            loadDialog: false,
            file: null,
            uploadingProof: false,
            simulatingPay: false,
            loadingInstance:undefined
        };
    },
    mounted() {
        this.fetchData()
    },
    computed: {
        isPaymentCompleted() {
            const info = this.applicationInfo || {}
            const status = info.application_status
            if (status === '已缴费' || status === '无需缴费') {
                return true
            }
            // Combo half-pay / simulate: payment already written even if status is pending activation
            if (info.application_payment_channel && status !== '待缴费' && status !== '未缴费') {
                return true
            }
            return false
        },
        institutionAmounts() {
            const amounts = calcInstitutionOrderAmounts({
                standardFee: this.standard_fee || this.applicationInfo.institution_price || 0,
                reduction: 0,
                serviceFee: this.serviceFee,
                method: this.paymentMethod
            })
            // C-3: test accounts show and charge Stripe floor on Stripe card path
            if (isTestUser() && this.paymentMethod === 'card') {
                return {
                    ...amounts,
                    svc: 0,
                    total: getTestPayAmountUsd()
                }
            }
            return amounts
        }
    },
    methods: {

        fetchData() {
            const loading = this.$loading({
                lock: true,
                text: "Loading",
                spinner: "el-icon-loading",
                background: "rgba(0, 0, 0, 0.7)",
            });
            
            checkApplication(this.application_id).then((res) => {
                this.applicationInfo = res.data.data
                this.isInstitutionPayment = this.applicationInfo.institution_payment_enabled === 'YES'
                this.project_refund_policy = this.isInstitutionPayment
                    ? this.getInstitutionTermsPolicy(this.applicationInfo)
                    : this.applicationInfo.project_info.project_refund_policy
                if (this.project_refund_policy && String(this.project_refund_policy).trim() != '') {
                    this.project_refund_policy = this.project_refund_policy.replaceAll('\r\n\r\n', '<br><br>')
                } else {
                    this.project_refund_policy = this.getDefaultRefundPolicy()
                }
                this.currency = this.applicationInfo.project_info.project_price_currency
                this.serviceFee = this.applicationInfo.service_fee
                this.standard_fee = this.applicationInfo.standard_fee
                this.amount = this.applicationInfo.total_price > 0 ? this.applicationInfo.service_fee + this.applicationInfo.total_price : this.applicationInfo.total_price
                if(this.amount <=0 ){
                    this.amount = 0
                }
                // For institution payment page display amount, keep >0 if net fee > 0
                if (this.isInstitutionPayment && Number(this.applicationInfo.total_price || 0) > 0) {
                    this.amount = Math.max(this.amount, Number(this.applicationInfo.total_price))
                }
                loading.close()
            }).catch((err) => {
                console.error('Error fetching application data:', err)
                this.$message.error('Failed to load application data. Please try again.')
                loading.close()
            })
        },
        getDefaultRefundPolicy() {
            return [
                '<strong>Payment Instructions:</strong><br>',
                'Before completing any payment, it is essential to carefully review and agree to this refund policy. For any questions or concerns regarding the refund policy, you may contact us at <a href="mailto:contact@eae.international">contact@eae.international</a> for clarification.',
                '<br><br>',
                'If you disagree with or have reservations about the refund policy, you may choose to terminate the registration process and cancel your payment. Additionally, if you find the refund conditions—including the non-refundable amount, non-refundable timeline, or breach of contract terms—to be unsuitable, you may withdraw from the registration prior to payment.',
                '<br><br>',
                '<strong>Refund Policy:</strong><br>',
                'Due to the nature of digital services, once payment is finalized, you will gain access to the system and associated digital resources. This access constitutes full delivery of the service, and as such, no refund will be provided.',
                '<br><br>',
                '<strong>No Refund for Integrity-Related Cancellations:</strong><br>',
                'Where an examination score or competition result is cancelled, invalidated, or otherwise forfeited due to a confirmed integrity violation—including academic dishonesty, payment fraud, or a cross-program cancellation under EAE\'s integrity policy—all fees paid in connection with the affected program or competition are non-refundable. The candidate shall not be entitled to a refund, chargeback, or any other form of compensation in respect of any such cancellation.',
                '<br><br>',
                'By proceeding with payment, you acknowledge and accept the terms outlined in this refund policy.'
            ].join('')
        },
        getDefaultInstitutionTermsPolicy() {
            return getInstitutionOrderTermsHtml()
        },
        getInstitutionTermsPolicy(applicationInfo) {
            // C-6: institution orders always use prototype refund policy (not student project terms).
            void applicationInfo
            return getInstitutionOrderTermsHtml()
        },
        calcReductionFee() {
            let fee = this.standard_fee - (this.applicationInfo.total_price)
            return fee
        },
        formatAmount(amount) {
            return Number(amount || 0).toFixed(2)
        },
        formatProofUploadedTime(ts) {
            if (!ts) return ''
            const d = new Date(Number(ts) * (String(ts).length > 10 ? 1 : 1000))
            if (isNaN(d.getTime())) return ''
            return d.toLocaleDateString() + ' ' + d.toLocaleTimeString()
        },
        goBack() {
            this.$router.go(-1)
        },
        goPay() {

            if (!this.isAgree) {
                this.$message.warning(this.isInstitutionPayment
                    ? 'Accept the terms and conditions to continue.'
                    : 'Please read terms and agree it');
                return;
            }
            if (!this.isInstitutionPayment && !this.isCardholderAgree) {
                this.$message.warning("Please confirm that the cardholder has been informed and has authorized the transaction");
                return;
            }

            // Get project deadline and compare with local time
            console.log('deadline_date',this.applicationInfo?.project_info?.deadline_date);
            if (this.applicationInfo?.project_info?.deadline_date) {
                const deadlineDate = new Date(this.applicationInfo.project_info.deadline_date + (24*3600-1)*1000);
                const localTime = new Date();
                // Get local deadline at 23:59:59 of the same date
                const localDeadline = new Date(deadlineDate.getFullYear(), deadlineDate.getMonth(), deadlineDate.getDate(), 23, 59, 59);
                

                console.log('localDeadline', localDeadline.toLocaleString());
                console.log('localTime', localTime.toLocaleString());
                console.log('deadlineDate', deadlineDate.toLocaleString());
                
                if (localTime > localDeadline) {

                    if(this.applicationInfo.custom_deadline_date){
                        const customDeadlineDate = new Date(this.applicationInfo.custom_deadline_date + (24*3600-1)*1000);
                        const localCustomDeadline = new Date(customDeadlineDate.getFullYear(), customDeadlineDate.getMonth(), customDeadlineDate.getDate(), 23, 59, 59);
                        if(localTime > localCustomDeadline){
                            this.$message.warning("The registration deadline has passed. Please contact support if you need assistance.");
                            return;
                        }
                    }else{
                        this.$message.warning("The registration deadline has passed. Please contact support if you need assistance.");
                        return;
                    }
                    
                }
            }
            if (this.applicationInfo.application_status != "待缴费") {
                this.$message.success('Payment has already been completed.')
                this.goBack()
                return
            }
            if (isTestUser()) {
                this.$confirm(
                    'This is a test account. Simulate payment (no real charge), or continue with real Stripe checkout?',
                    'Test account payment',
                    {
                        distinguishCancelAndClose: true,
                        confirmButtonText: 'Simulate payment',
                        cancelButtonText: 'Real Stripe pay',
                        type: 'warning'
                    }
                ).then(() => {
                    this.doSimulatePay()
                }).catch((action) => {
                    if (action === 'cancel') {
                        this.openRealStripePay()
                    }
                })
                return
            }
            this.openRealStripePay()
        },
        openRealStripePay() {
            let url = this.$router.resolve({
                path: "/program-pay",
                query: {
                    application_id: this.application_id,
                },
            });
            window.open(url.href, "_blank");
        },
        doSimulatePay() {
            if (this.simulatingPay) return
            this.simulatingPay = true
            const loading = this.$loading({
                lock: true,
                text: 'Simulating payment...',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)',
            })
            simulateProgramPayment(this.application_id, getUserId()).then((res) => {
                loading.close()
                this.simulatingPay = false
                if (res.data && res.data.code === 0) {
                    this.$message.success('Simulated payment applied.')
                    // Match real Stripe return_url: ProgramStripEmbedCallBack → /home/programs
                    this.$router.replace({ path: '/home/programs' })
                } else {
                    this.$message.error((res.data && res.data.msg) || 'Simulate payment failed.')
                }
            }).catch((err) => {
                loading.close()
                this.simulatingPay = false
                console.error('simulateProgramPayment failed', err)
                this.$message.error('Simulate payment failed. Please try again.')
            })
        },
        downloadInvoice() {
            this.$router.push({
                path: '/home/schoolInvoice',
                query: {
                    id: this.application_id,
                    document: 'invoice'
                }
            })
        },
        async beforeProofUpload(file) {
            if (!this.isAgree) {
                this.$message.warning('Please accept the terms and conditions before uploading proof of payment.')
                return false
            }
            const isAllowedType = ['application/pdf', 'image/jpeg', 'image/png'].includes(file.type)
            if (!isAllowedType) {
                this.$message.warning('Please upload a PDF, JPG, or PNG file.')
                return false
            }
            if (file.size / 1024 / 1024 > 10) {
                this.$message.warning('Proof file must be 10MB or smaller.')
                return false
            }
            this.uploadingProof = true
            try {
                const result = await getQiniuToken()
                if (!result.data || result.data.code !== 0) {
                    this.uploadingProof = false
                    this.$message.error('Failed to prepare upload token.')
                    return false
                }
                const safeName = file.name.replace(/[^a-zA-Z0-9._-]/g, '_')
                const key = 'institution-payment-proof/' + new Date().getTime() + '-' + safeName
                qiniu.upload(file, key, result.data.data).subscribe({
                    error: () => {
                        this.uploadingProof = false
                        this.$message.error('Upload failed. Please try again.')
                    },
                    complete: (res) => {
                        const proofUrl = 'https://ap.learningfirst.io/' + res.key
                        updateInstitutionPaymentProof({
                            application_id: this.application_id,
                            proof_url: proofUrl,
                            proof_file_name: file.name,
                            uploaded_by: getUserId() || ''
                        }).then((saveRes) => {
                            this.uploadingProof = false
                            if (saveRes.data && saveRes.data.code === 0) {
                                this.$message.success('Proof uploaded. Finance will verify the payment.')
                                this.applicationInfo = Object.assign({}, this.applicationInfo, saveRes.data.data || {})
                            } else {
                                this.$message.error(saveRes.data?.msg || 'Failed to save proof information.')
                            }
                        }).catch(() => {
                            this.uploadingProof = false
                            this.$message.error('Failed to save proof information.')
                        })
                    }
                })
            } catch (e) {
                this.uploadingProof = false
                this.$message.error('Upload failed. Please try again.')
            }
            return false
        },
        getTuitionTier() {
            if (!this.applicationInfo || !this.applicationInfo.reduction_level_info) {
                return 1; // Default value if data is not available
            }
            
            const reductionInfo = this.applicationInfo.reduction_level_info;
            return reductionInfo.reduction_level - reductionInfo.country_level + 1 - reductionInfo.target_offer;
        },
        getFile(event) {
            if (event && event.target && event.target.files) {
                this.file = event.target.files[0];
            }
        },
        submitTier(){


            this.loadingVisible = true;
               this.loadingInstance =  this.$loading({
                    lock: true,
                    text: 'Uploading file...',
                    spinner: 'el-icon-loading',
                    background: 'rgba(0, 0, 0, 0.7)'
                });

            this.uploadVideoFile()


        },
        async getQiniuToken () {
            return new Promise((resolve) => {
                getQiniuToken().then((res) => {
                    resolve(res)
                })
            })
        },
        async uploadVideoFile () {
            console.log(1232131213)

            const result = await this.getQiniuToken()

            console.log(8888, result)

            if (result.data.code === 0) {
            console.log(1222)

            this.proVisible = true
            this.process = 1

            const token = result.data.data
            this.observable = qiniu.upload(
                this.file,
                new Date().getTime() + this.file.name,
                token
            )
            const observer = {
                complete: (res) => {
                var url = 'https://ap.learningfirst.io/' + res.key
                this.submitTierInfo(url)

                },
                next: (res) => {
                // this.process = parseFloat(res.total.percent.toFixed(1))
                }
            }
            this.observable.subscribe(observer)
            } else {
                if(this.loadingInstance){
                    this.loadingInstance.close()
                }
                this.dialogVisible = false
            }
        },

        submitTierInfo(url){

            uploadStudentTuitionTier(getUserId(),this.applicationInfo.project_info.project_code,url ).then((res) => {

                if (res.data.code == 0) {
                this.$message.success('Submit Successfully')
                } else {
                this.$message.error(res.msg);
                }
            }).finally(()=>{
                if(this.loadingInstance){
                    this.loadingInstance.close()
                }
                this.dialogVisible = false
            });

                this.loadDialog = false
                
        },
        removeFile() {
            this.file = null;
        }
    }
};
</script>

<style lang="scss" scoped>
::-webkit-scrollbar {
    display: none;
}

.btn {
    width: 160px;
}

.terms {
    margin-top: 10px;
    width: 100%;
    background-color: #F4F4F4;
    padding: 20px 30px;
    box-sizing: border-box;
    color: #666;
    font-size: 16px;
    line-height: 24px;
}

.btn {
    width: 160px;
}

.pay-info {
    border-radius: 12px;
    background-color: #FFF8F8;
    color: #333;
    border: 1px solid #DEDEDE;
    padding: 20px 40px;
    box-sizing: border-box;
    margin-top: 30px;
}

.bank-transfer-grid {
    border: 1px solid #e4e7ed;
    border-radius: 6px;
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    margin-top: 14px;
    overflow: hidden;

    div {
        background: #fff;
        border-bottom: 1px solid #e4e7ed;
        padding: 12px 14px;

        &:nth-child(odd) {
            border-right: 1px solid #e4e7ed;
        }
    }

    span {
        color: #909399;
        display: block;
        font-size: 12px;
        margin-bottom: 4px;
    }

    strong {
        color: #303133;
        font-size: 13px;
        word-break: break-word;
    }
}

.bank-policy {
    color: #606266;
    font-size: 14px;
    line-height: 22px;
    margin-top: 14px;

    p {
        margin-bottom: 8px;
    }
}

.institution-proof-status {
    align-items: center;
    background: #f0f9eb;
    border: 1px solid #c2e7b0;
    border-radius: 6px;
    display: flex;
    gap: 12px;
    justify-content: center;
    margin-top: 14px;
    padding: 10px 12px;

    a {
        color: #409eff;
    }

    span {
        color: #67c23a;
        font-size: 13px;
    }
}

.bank-upload-note {
    color: #909399;
    font-size: 12px;
    margin-top: 10px;
    text-align: center;
}

.amt-orange {
    font-weight: bold;
    color: #ff8e3b;
    font-family: ui-monospace, SFMono-Regular, Menlo, Consolas, monospace;
}

.method-chips {
    display: inline-flex;
    border: 1px solid #D3D1C7;
    border-radius: 8px;
    overflow: hidden;
}

.method-chip {
    border: none;
    background: #fff;
    color: #6B6B64;
    padding: 6px 12px;
    font-size: 12.5px;
    cursor: pointer;
}

.method-chip + .method-chip {
    border-left: 1px solid #D3D1C7;
}

.method-chip.active {
    background: #185FA5;
    color: #fff;
}

.svc-tag {
    font-size: 11.5px;
    color: #8A8A82;
    margin-left: 6px;
    font-weight: 400;
}

.institution-terms-box {
    margin-top: 12px;
    max-height: 230px;
    overflow: auto;
    border: 1px solid #E3E3DE;
    border-radius: 10px;
    padding: 14px 16px;
    background: #FCFCFA;
    font-size: 13px;
    color: #6B6B64;
    line-height: 1.6;
}

.terms-note {
    margin-top: 10px;
    font-size: 12.5px;
    color: #8A8A82;
    min-height: 18px;
}

.institution-action-btn {
    max-width: 260px;
    white-space: normal;
    height: auto;
    line-height: 1.3;
    padding-top: 10px;
    padding-bottom: 10px;
}

.institution-proof-panel {
    margin-top: 14px;
    border: 1px solid #FAC775;
    background: #FAEEDA;
    border-radius: 10px;
    padding: 13px 15px;
    font-size: 13px;
    color: #854F0B;
}

.institution-proof-panel .proof-name {
    font-weight: 500;
    color: #22221F;
}

.institution-proof-panel .proof-meta {
    font-size: 12px;
    color: #8A8A82;
    margin-top: 3px;
}

.fee-reduction-dialog {
    /deep/ .el-dialog__body {
        padding: 20px 25px;
    }
    
    /deep/ .el-dialog__header {
        padding: 15px 25px;
        background-color: #f5f7fa;
        border-bottom: 1px solid #e4e7ed;
    }
    
    /deep/ .el-dialog__title {
        font-weight: 600;
        color: #303133;
    }
}

.pdf-container {
    height: 550px;
    overflow-y: auto;
    padding: 15px;
    border: 1px solid #e4e7ed;
    border-radius: 4px;
    background-color: #f9f9f9;
    
    &::-webkit-scrollbar {
        width: 8px;
    }
    
    &::-webkit-scrollbar-thumb {
        background-color: #c0c4cc;
        border-radius: 4px;
    }
    
    &::-webkit-scrollbar-track {
        background-color: #f5f7fa;
    }
}

.reduction-panel {
    height: 100%;
    padding: 15px;
    border: 1px solid #e4e7ed;
    border-radius: 4px;
    background-color: #ffffff;
    display: flex;
    flex-direction: column;
}

.panel-title {
    margin-top: 0;
    margin-bottom: 15px;
    color: #303133;
    font-size: 18px;
    text-align: center;
    font-weight: 600;
}

.reduction-info-card {
    margin-bottom: 20px;
    border: 1px solid #e4e7ed;
    border-radius: 6px;
    overflow: hidden;
}

.reduction-main-info {
    padding: 15px;
    background-color: #ecf5ff;
    border-bottom: 1px solid #d9ecff;
    display: flex;
    align-items: center;
    justify-content: space-between;
}

.reduction-level {
    display: flex;
    flex-direction: column;
    
    .level-label {
        font-size: 14px;
        color: #606266;
    }
    
    .level-value {
        font-size: 32px;
        font-weight: bold;
        color: #409EFF;
        line-height: 1;
    }
}

.level-formula {
    padding: 6px 12px;
    background-color: rgba(255, 255, 255, 0.8);
    border-radius: 4px;
    font-size: 14px;
    color: #606266;
}

.info-details {
    padding: 15px;
    background-color: #ffffff;
}

.info-item {
    display: flex;
    justify-content: space-between;
    margin-bottom: 8px;
    font-size: 14px;
    
    &:last-child {
        margin-bottom: 0;
    }
    
    .info-label {
        color: #909399;
    }
    
    .info-value {
        font-weight: 500;
        color: #303133;
    }
}

.info-box {
    background-color: #f0f9eb;
    border-left: 4px solid #67c23a;
    padding: 10px 15px;
    margin-bottom: 20px;
    border-radius: 4px;
}

.info-text {
    color: #606266;
    font-size: 14px;
    line-height: 1.5;
    margin: 0;
    word-break: keep-all;
    white-space: normal;
    hyphens: none;
    overflow-wrap: break-word;
    
    &.instruction {
        color: #909399;
        font-size: 13px;
        font-style: italic;
        margin-top: 10px;
    }
}

.upload-section {
    margin-bottom: 20px;
}

.upload-container {
    position: relative;
    display: flex;
    justify-content: center;
    margin-bottom: 10px;
}

.file-input {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    opacity: 0;
    cursor: pointer;
    z-index: 10;
}

.upload-button {
    width: 100%;
    padding: 12px 20px;
}

.file-name {
    display: flex;
    align-items: center;
    padding: 8px 12px;
    background-color: #f5f7fa;
    border-radius: 4px;
    margin-top: 10px;
    
    i {
        color: #909399;
        
        &.el-icon-document {
            margin-right: 5px;
            color: #409EFF;
        }
        
        &.el-icon-delete {
            margin-left: auto;
            cursor: pointer;
            &:hover {
                color: #F56C6C;
            }
        }
    }
    
    span {
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        color: #606266;
        word-break: keep-all;
        white-space: normal;
        hyphens: none;
        overflow-wrap: break-word;
    }
}

.actions {
    margin-top: auto;
    display: flex;
    justify-content: flex-end;
    gap: 10px;
}

/* Apply the same style to other text elements */
.level-formula span,
.info-item .info-label,
.info-item .info-value,
.file-name span {
    word-break: keep-all;
    white-space: normal;
    hyphens: none;
    overflow-wrap: break-word;
}

.empty-bottom {
   width: 100%;
   height: 100px;
}
</style>
